import { binSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const binReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case binSelectors.GET_BIN:
      return {
        ...state,
        loading: true,
      };
    case binSelectors.GET_BIN_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
